import React, { useContext } from "react";
import BaseTooltip from "@edaz/edazkit/Tooltip";
import { OverlayTriggerProps as OverlayTriggerBootstrapProps } from "react-bootstrap/OverlayTrigger";
import { Col, Row } from "react-bootstrap";
import Button from "@edaz/edazkit/Button";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import { BoxWidgetContext } from "../views/boxWidgetView";

interface OverlayTriggerBaseProps extends Omit<Omit<OverlayTriggerBootstrapProps, "overlay">, "container"> {
  tooltip: React.ReactElement | React.ReactNode | React.ReactNodeArray;
  id: string;
  className?: string;
  onClose?: () => void;
}

const Tooltip = (props: OverlayTriggerBaseProps) => {
  const container = useContext(BoxWidgetContext);

  return (
    <BaseTooltip
      {...props}
      tooltip={
        <div className="m-2 position-relative">
          {props.onClose && (
            <Button variant="link" onClick={props.onClose} className="p-0 m-0 right-corner">
              <Icon width={8} height={8} className="text-white-50" icon={IconType.Cross} />
            </Button>
          )}
          <Row>
            <Col xs={12}>{props.tooltip}</Col>
          </Row>
        </div>
      }
      container={container}>
      {props.children}
    </BaseTooltip>
  );
};

export default Tooltip;
